import { CurrencyAccountSelect } from '@/features/account-select';

import { CurrencySelectTrigger } from '@/entities/currency';
import { ICurrencyAccount } from '@/entities/currency-account';

import { AmountInput, Heading } from '@/shared/ui';

interface CurrencyWithAmountProps {
  currency: ICurrencyAccount;
  value: number;
  onAmountChange: (value: number) => void;
  onCurrencyChange: (currency: ICurrencyAccount) => void;
  excludedCodes?: string[];
  isDisabled?: boolean;
  isAmountDisabled?: boolean;
}

export const CurrencyWithAmount = ({
  currency,
  value,
  onAmountChange,
  excludedCodes,
  onCurrencyChange,
  isDisabled,
  isAmountDisabled,
}: CurrencyWithAmountProps) => {
  return (
    <div className="flex items-center p-5">
      <Heading className="font-black" variant="s" tag="span">
        {currency?.symbol}
      </Heading>
      <AmountInput
        value={value}
        onChange={onAmountChange}
        className="ml-1"
        isDisabled={isAmountDisabled ?? isDisabled}
      />
      <CurrencyAccountSelect
        isDisabled={isDisabled}
        selected={currency}
        excludedCodes={excludedCodes}
        isCurrencyOnly
        title="Choose a currency"
        onSelect={onCurrencyChange}
        excludeAllAccounts
        customTrigger={
          <CurrencySelectTrigger
            code={currency?.code}
            name={currency?.currencyName}
          />
        }
      />
    </div>
  );
};
